import { DataGrid } from "devextreme-react";
import {
  Column,
  Export,
  FilterRow,
  HeaderFilter,
  SearchPanel,
} from "devextreme-react/cjs/data-grid";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { actionEndorsmentList, resetEndorsmentList } from "../store";
import ListDateFilters from "../../../../../component/filters/list_date_filters";
import ListCalendarFilter from "../../../../../component/filters/list_calendar_filter";
import { getLocalStorageItem, onExporting } from "../../../../../utils";
import { useNavigate, useLocation } from "react-router-dom";
import BulkUpload from "../../../../../component/bulk_upload";
import Swal from "sweetalert2";
import $ from "jquery";
import Loader from "../../../../../component/page_loader";
import toast from "react-hot-toast";
import {
  TOAST_DURATION,
  TOAST_ERROR_COLOR,
  TOAST_POSITION,
} from "../../../../../common/app_constant";
import { useForm } from "react-hook-form";

const EndorsementList = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { register, watch, setValue } = useForm();
  const [uploadBulk, setUploadBulk] = useState(false);
  const [viewEndorsmentList, setViewEndorsmentList] = useState([]);
  const [role, setRole] = useState();
  const [isLoader, setIsLoader] = useState(true);
  const watchSubType = watch("reason");
  const { EndorsmentList } = useSelector((state) => ({
    ...state.listStore,
  }));

  const renderDateCell = (date) => {
    const formattedDate = moment(date).isValid()
      ? moment(date).format("DD-MMM-YYYY")
      : "-";
    return formattedDate;
  };

  const rendercapitalizeData = (value) => {
    const captitalize = value
      ? value.charAt(0).toUpperCase() + value.slice(1)
      : "-";
    return captitalize;
  };

  const updateFromDate = (newFromDate) => {
    setFromDate(newFromDate);
  };

  const updateToDate = (newToDate) => {
    setToDate(newToDate);
  };

  const finalFromDate = (newFromDate) => {
    fromDate(newFromDate);
  };

  const finalToDate = (newToDate) => {
    toDate(newToDate);
  };

  const handleResetClick = () => {
    setFromDate(initialFromDate); // Reset fromDate to its initial value
    setToDate(initialToDate); 
    setValue('reason', 'All')
    // Reset fromDate to its initial value
  };

  const initialFromDate = "";
  // moment(new Date())
  // .subtract(2, "month")
  // .format("YYYY-MM-DD");
  const initialToDate = "";
  // moment(new Date())
  // .add(4, "month").format("YYYY-MM-DD"); // Initial value for toDate

  const [fromDate, setFromDate] = useState(initialFromDate);
  const [toDate, setToDate] = useState(initialToDate);

  useEffect(() => {
    dispatch(actionEndorsmentList({
       from_date: fromDate,
      to_date: toDate,
      reason: watchSubType === "All" ? "" : watchSubType,
    }));
  }, []);

  useEffect(() => {
    dispatch(resetEndorsmentList());
    if (EndorsmentList) {
      setIsLoader(false);
      setViewEndorsmentList(EndorsmentList.data);
    }
  }, [EndorsmentList]);

  useEffect(() => {
    setRole(getLocalStorageItem("next"));
  
      dispatch(
        actionEndorsmentList({
          from_date: fromDate,
          to_date: toDate,
          reason: watchSubType === "All" ? "" : watchSubType,
        })
      );

  }, [toDate, fromDate, watchSubType]);

  // Render action -edit
  const renderAction = data => (
    <>
     
        <button
          className={`btn btn-sm btn-primary cursor-pointer`}
          onClick={() => {
            if (data) {
                        console.log("=======",JSON.stringify(data));
                        navigate("/employer/endorsement-update", { state: { data: data } });
                      
            }
          }}
        >
          Edit
        </button>
     
          {/* <button
            className={`btn btn-sm btn-primary cursor-pointer mx-1`}
            onClick={() => {
                      Swal.fire({
                        icon: "warning",
                        text: "Are you sure, you want to delete this document?",
                        cancelButtonText: "Cancel",
                        showCancelButton: true,
                      }).then(({ isConfirmed }) => {
                        if (isConfirmed) {
                          alert('delete api call')
                           dispatch()
                        }
                      });
                    }}
          >
            Delete
          </button> */}
        
    </>
  );

  // const renderAction = (data) => (
  //   <div className="row">
  //     <i
  //       className="col-6 fa fa-pencil fa-lg cursor-pointer primary2 float-left"
  //       onClick={() => {
  //         if (data) {
  //           console.log("=======",JSON.stringify(data));
  //           navigate("/employer/endorsement-update", { state: { data: data } });
  //         }
  //       }}
  //     > <button
  //     className={`btn btn-sm btn-primary cursor-pointer`}>Edit</button></i>
  //     <i
  //       className={`col-6 fa fa-trash fa-lg cursor-pointer primary2 float-right`}
  //       onClick={() => {
  //         Swal.fire({
  //           icon: "warning",
  //           text: "Are you sure, you want to delete this document?",
  //           cancelButtonText: "Cancel",
  //           showCancelButton: true,
  //         }).then(({ isConfirmed }) => {
  //           if (isConfirmed) {
  //             // alert('delete api call')
  //             //  dispatch()
  //           }
  //         });
  //       }}
  //     >
  //       <button className={`btn btn-sm btn-primary cursor-pointer`}>Delete</button>
  //     </i>
  //   </div>
  // );
  // Make and Modal render cell
  const renderMakeModal = (data) => {
    // Access the necessary data properties from the data object
    const field1 = data.policyDetails.vehicle_make; // Assuming field1 is one of the fields you want to merge
    const field2 = data.policyDetails.vehicle_model; // Assuming field2 is the other field you want to merge

    // Merge the fields (example: concatenating them)
    const mergedValue = `${field1} - ${field2}`;

    // Return the merged value
    return mergedValue;
  };
  return (
    <>
      <div className="row justify-content-center pb-5 mt-6">
        <div className="col-12 mb-5">
          <div className="d-flex justify-content-between mb-2">
            <div className="">
              <h5 className="mb-0">Endorsement List</h5>
            </div>
            {role == "copsdashboard" && (
              <div>
                <button
                  className={`btn btn-sm btn-primary cursor-pointer me-2`}
                  onClick={() => {
                    setUploadBulk(true);
                  }}
                >
                  Add Bulk
                </button>
                <button
                  className={`btn btn-sm btn-primary cursor-pointer`}
                  onClick={() => {
                    navigate("/employer/endorsement-update");
                  }}
                >
                  Add
                </button>
              </div>
            )}
          </div>
          {/* renewal date filter */}
          <ListDateFilters
            lebel1={"Endorsement Date From"}
            lebel2={"Endorsement Date To"}
            updateFromDate={updateFromDate}
            updateToDate={updateToDate}
            resetClick={handleResetClick}
            fromDate={fromDate}
            toDate={toDate}
          />
          {isLoader === true ? (
            <Loader />
          ) : (
            <div className="card border mt-3">
              <div className="card-header">
                {/* calender filter component */}
                <ListCalendarFilter
                  updateFromDate={updateFromDate}
                  updateToDate={updateToDate}
                  finalFromDate={finalFromDate}
                  finalToDate={finalToDate}
                />
              </div>
              <div className="card-body position-relative">
                <div className="position-absolute z-index-9 w-25">
                  <select
                    className="form-select fw-bold text-primary"
                    name="reason"
                    id="reason"
                    placeholder="Select"
                    {...register("reason")}
                  >
                      {[
                        "All",
                        "Vehicle No Update",
                        "NCB Recovery",
                        "RC Transfer",
                        "Accessory Addition",
                        "RTO Modification",
                        "Others",
                        "Address Correction",
                        "Name Correction",
                      ].map(option => (
                        <option key={option} value={option}>
                          {option} {watch('reason') === option && `(${viewEndorsmentList?.length})`}
                        </option>
                      ))}
                  </select>
                </div>
                <DataGrid
                  id="endorsment_list"
                  dataSource={viewEndorsmentList}
                  columnMinWidth={100}
                  showBorders={true}
                  filterSyncEnabled={false}
                  allowColumnResizing={true}
                  columnAutoWidth={true}
                  onExporting={onExporting}
                >
                  <HeaderFilter visible={true} />
                  <SearchPanel visible={true} />
                  <FilterRow visible={true} />
                  {role == "copsdashboard" && (
                    <Column
                      dataField="action"
                      caption="Action"
                      cellRender={({ data }) => renderAction(data)}
                    />
                  )}
                  <Column
                    dataField="index"
                    caption="S.No"
                    dataType="number"
                    cellRender={(rowData) => {
                      return rowData?.rowIndex != null
                        ? Number(rowData?.rowIndex + 1)
                        : "-";
                    }}
                  />
                  <Column
                    dataField="type"
                    caption="Type"
                    cellRender={({ value }) => rendercapitalizeData(value)}
                  />
                  <Column
                    dataField="policyDetails.userDetails.full_name"
                    caption="Full Name"
                  />
                  {/* <Column
                  dataField="policyDetails.userDetails.mobile"
                  caption="Emp Mobile Number "
                  dataType="string"
                /> */}
                  <Column
                    dataField="policyDetails.userDetails.userCity.cityState.stateZone.name"
                    caption="Emp Zone "
                  />
                  {/* <Column
                  dataField="policyDetails.userDetails.email"
                  caption="Emp Email ID  "
                /> */}
                  <Column
                    dataField="policyDetails.vehicle_no"
                    caption="Vehicle Number"
                  />
                  <Column
                    dataField="vehicle_make_model"
                    caption="Vehicle Make & Model"
                    width={80}
                    cellRender={({ data }) => renderMakeModal(data)}
                  />

                  <Column
                    dataField="policyDetails.policy_no"
                    caption="Policy Number "
                  />

                  <Column
                    dataField="policy_expiry_date"
                    caption="Policy Due Date"
                    dataType="date"
                    cellRender={({ value }) => renderDateCell(value)}
                  />
                  <Column dataField="endorsement_no" caption="Endorsement NO" />
                  <Column dataField="type" caption="Endorsement Type" />
                  <Column
                    dataField="endorsement_date"
                    caption="Endorsement Date"
                  />
                  <Column dataField="net_amount" caption="Endorsement Net " />
                  <Column dataField="gst_amount" caption="GST " />
                  <Column
                    dataField="total_amount"
                    caption="Endorsement Total"
                  />
                  <Column dataField="status" caption="Current Status" />
                  <Column
                    dataField="paid_through"
                    caption="Endorment Payment (Paid Through)"
                  />
                  <Column dataField="remark" caption="OPS Remarks" />
                  <Column
                    dataField="lastUpdatedBy.full_name"
                    caption="Last Modified By"
                  />
                  <Column
                    dataField="lastUpdatedBy.formatted_updated_at"
                    caption="Last Modified Date"
                  />
                  <Column dataField="" caption="Endorsement Document" />
                  <Export enabled={true} />
                </DataGrid>
              </div>
            </div>
          )}
        </div>
      </div>
      <BulkUpload
        show={uploadBulk}
        module="endorsement"
        dynamic_url="importendorsement"
        handleUpdateList={() => {
          setUploadBulk(false);
          dispatch(
            actionEndorsmentList({
              renewal_from: fromDate,
              renewal_to: toDate,
              reason: watchSubType === "All" ? "" : watchSubType,
            })
          );
        }}
      />
    </>
  );
};

export default EndorsementList;
